import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { PropertyService, Property } from '@app/_components/property';
import { AlertService, AuthenticationService, ConstantService, DataCacheService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { Table } from 'primeng/table';
import { Dropdown } from 'primeng/dropdown';

@Component({
    selector: 'app-propery-summary-list',
    templateUrl: './propery-summary-list.component.html',
    styleUrls: ['./propery-summary-list.component.css'],
    standalone: false
})
export class PropertySummaryListComponent implements OnInit {
	@ViewChild('pt') pt: Table | undefined;
	@ViewChild('aa') public aa: Dropdown;
	datasource: Property[];
	description: any;
	descriptions: any[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];
	notesLength: number;

	listingStatuses = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Canceled' }
	];
	locationIds: any[];

	constructor(
		private authenticationService: AuthenticationService,
		private propertyService: PropertyService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private constantService: ConstantService,

		private router: Router
	) {
		this.locationIds = this.constantService.locations;
	 }


	ngOnInit() {
		try {
			} catch (error) {
			console.log('ngOnInit() ' + error);

		}
	}
	
	/*********
	 * Cell Edit Callbacks (if using cell edit feature).
	 * Remove editMode="row" in p-table
	 * Remove <tr [pEditableRow]="test"> and just have plain <tr>
	 * Add <td [pEditableColumn]="test" [pEditableColumnField]="'name'"> for each cell <td>
	 * Update <ng-template pTemplate="body" let-test>
	 *
	 */
	onCellEditInit(event: any): void { }
	onCellEditComplete(event: any): void { this.formUpdate(event.data); }
	onCellEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }


	/*********
	 * Row Edit Callbacks (if using row edit feature)
	 * Add editMode="row" in p-table
	 * Add <tr [pEditableRow]="test"> for the <tr>
	 * Remove <td [pEditableColumn]="test" [pEditableColumnField]="'name'"> for each cell <td>
	 * <ng-template pTemplate="body" let-test let-editing="editing" let-ri="rowIndex">
	 */
	onRowEditInit(property: Property): void { }
	onRowEditSave(property: Property): void { }
	onRowEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }

	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyService.findDescriptions(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					data => {
						console.log('desciptions are: ' + JSON.stringify(data));
						this.datasource = data.data.descriptions;
						this.recordTotal = data.page.recordTotal;
						this.descriptions = data.data.descriptions;
					},
					error => {
						console.log('descriptions list error!: ' + JSON.stringify(error));
						this.alertService.error(error);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.descriptions = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {
		try {
			this.loading = true;
			// console.log('onRowSelect(' + JSON.stringify(event) + ')');
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['property-edit', event.data.shortTermRentalId]);
		} catch (error) {
			console.log('onRowSelect(' + event + ')' + error);
		}
	}

	get Locations() {
		return Locations;
	}
	get ListingStatus() {
		return ListingStatus;
	}

	reloadPage() {
		window.location.reload();
	}



	
	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(description: any) {
		try {
			console.log('Trying to update ' + JSON.stringify(description));
			this.propertyService.updateDescription(description)
				.subscribe(
					(res: any) => {
						console.log('Description-Update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => {  });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	
	maxLength(event: any) {
	  console.log('Key press', event);
	  this.notesLength = event.target.textLength;
	}
	
	onKeyup(event: any) {
	  this.notesLength = event.target.textLength;
	}
}
